import { isInternational } from 'helpers/location';
import { ValidateJSModel, ValidateJSModelAttribute } from 'forms/shared/types';
import pvqLocationModelValidator from '../pvqLocation';
import { LocationModel } from '../types';
import { inheritModel } from '../../shared/modelHelper';

interface LocationBirthplaceModel {
  city: LocationModel['city']
  state: LocationModel['state']
  country: LocationModel['country']
  county: LocationModel['county']
}

const pvqLocationBirthplaceModelValidator: ValidateJSModel<LocationBirthplaceModel> = {
  inUSA: (value, attributes, attributeName, options) => (options.ignoreUSBranch ? {} : { presence: true }),

  city: (value, attributes, attributeName, options) => {
    const inherited = inheritModel(
      pvqLocationModelValidator.city,
      value,
      attributes,
      attributeName,
      options
    );

    if (options.requireCity === false || (!!attributes.county && options.requireCityOrCounty)) {
      return {
        ...inherited,
        presence: false,
        length: {},
      };
    }
    return {
      ...inherited,
      presence: true,
    };
  },

  state: pvqLocationModelValidator.state as ValidateJSModelAttribute<LocationBirthplaceModel, 'state'>,

  country: pvqLocationModelValidator.country as ValidateJSModelAttribute<
    LocationBirthplaceModel,
    'country'
  >,

  county: (value, attributes, attributeName, options) => {
    const inherited = inheritModel(
      pvqLocationModelValidator.county,
      value,
      attributes,
      attributeName,
      options
    );

    if (
      options.requireCounty === false
      || isInternational(attributes)
      || (!!attributes.city && options.requireCityOrCounty)
    ) {
      return {
        ...inherited,
        presence: false,
      };
    }
    return {
      ...inherited,
      presence: true,
    };
  },
};

export default pvqLocationBirthplaceModelValidator;
